/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2024-03-19 15:01:10
 * @FilePath: \community-backendf:\community-frontend\src\stores\system.js
 * @Description: 
 */
import { defineStore } from "pinia"
import http from '@/service'

export const useSystemStore = defineStore('systemStore', {
  state: () => ({
    brandName: import.meta.env.VITE_BRAND.toLowerCase(),
    country: import.meta.env.VITE_COUNTRY.toLowerCase(),
    browserType: window.innerWidth >= 1024 ? 'web' : 'wap',
    hideNavigation: false,
    cloudConfig: {},
    customSetting: {
      liveStreamWhiteList:'loading'
    },
    exploreSortMenuSwitch: {},
    reportReasons: [],
    galleryList: [],
    reportTaskList:[],
    versionCode: 0,
    injectWebView: 0,
    ruleLink: '',
    milestoneList: [],
    milestongStyle: {},
    inspirationList: [],
    inspirationStyle: {},
    isDark: false,
    languageList: [
      {
        name: 'Deutsch',
        active: false,
        value: 'de-DE'
      },
      {
        name: 'English',
        active: true,
        value: 'en-GB'
      },
      {
        name: 'español',
        active: false,
        value: 'es-ES'
      },
      {
        name: 'Français',
        active: false,
        value: 'fr-FR'
      },
      {
        name: 'Filipino',
        active: false,
        value: 'fil-PH'
      },
      {
        name: 'Italiano',
        active: false,
        value: 'it-IT'
      },
      {
        name: 'Indonesia',
        active: false,
        value: 'id-ID'
      },
      {
        name: 'Português',
        active: false,
        value: 'pt-PT'
      },
      {
        name: 'Русский',
        active: false,
        value: 'ru-RU'
      },
      {
        name: 'Tiếng Việt',
        active: false,
        value: 'vi-VN'
      },
      {
        name: '简体中文',
        active: false,
        value: 'zh-CN'
      },
      {
        name: 'ไทย',
        active: false,
        value: 'th-TH'
      },
       {
        name: '繁体中文',
        active: false,
        value: 'zh-TW'
      },
      {
        name: 'ភាសាខ្មែរ',
        active: false,
        value: 'km-KH'
      },
      // {
      //   name: 'မြန်မာ',
      //   active: false,
      //   value: 'my-MM'
      // },
      // {
      //   name: 'عربي',
      //   active: false,
      //   value: 'ar-AR'
      // }
    ],
    homeTab: '',
    language: 'en-GB'
  }),
  getters: {
    isWeb (state) {
      return state.browserType === 'web'
    },
    isWap (state) {
      return state.browserType === 'wap'
    },
    isWechat () {
      return navigator.userAgent.toLowerCase().indexOf('micromessenger') >= 0
    },
    isEurop () {
      // 是否欧洲时区
      try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone.includes('Europe') 
      } catch {
        return false
      }
    },
    isWifi () {
      if (window.navigator.connection) {
        const { type } = window.navigator.connection
        return type === 'wifi' || !type
      }
      return false
    },
    // 用户举报原因
    getUserReportReasons (state) {
      const reasons = state.reportReasons.filter(i => i.type === 1)
      return reasons
    },
    // 帖子举报原因
    getThreadReportReasons (state) {
      const reasons = state.reportReasons.filter(i => i.type === 2)
      return reasons
    },
    // 评论举报原因
    getCommentReportReasons (state) {
      const reasons = state.reportReasons.filter(i => i.type === 3)
      return reasons
    },
    // 回复举报原因
    getReplyReportReasons (state) {
      const reasons = state.reportReasons.filter(i => i.type === 4)
      return reasons
    },
     // 回复举报原因
    getMessageReportReasons (state) {
      const reasons = state.reportReasons.filter(i => i.type === 5)
      return reasons
    },
    isApp () {
      // return true
      return (window.HeytapNativeApi && !!window.HeytapNativeApi.invoke) || /usercenter/i.test(navigator.userAgent.toLowerCase()) || (!!window.OppoStoreClientStoreJS && !!window.OppoStoreClientBaseJS && !!window.OppoStoreClientUserJS) || navigator.userAgent.toLowerCase().includes('oneplus') || window.OnePlusClientBaseJS || (navigator.userAgent.toLocaleLowerCase().includes('appmarket') || location.search.includes('fromAppRate'))
    },
    isParis () {
      return import.meta.env.VITE_COUNTRY === 'PARIS'
    },
    isGlobal () {
      return import.meta.env.VITE_COUNTRY === 'GLOBAL'
    },
    isChina () {
      return import.meta.env.VITE_COUNTRY === 'CHINA'
    },
    isIndia () {
      return import.meta.env.VITE_COUNTRY === 'IN'
    },
    isOppo () {
      return import.meta.env.VITE_BRAND === 'OPPO'
    },
    isOneplusStore () {
      return !!window.OnePlusClientBaseJS
    },
    isOppoStore () {
      return location.href.includes('storeapp') || (!!window.OppoStoreClientStoreJS && !!window.OppoStoreClientBaseJS && !!window.OppoStoreClientUserJS)
    },
    isOneplus () {
      return navigator.userAgent.toLowerCase().includes('oneplus') && (window.HeytapNativeApi && !!window.HeytapNativeApi.invoke)
    },
    isCommunityApp () {
      return this.isOneplus || this.isOppoApp
    },
    isMyOppo () {
      return ((window.HeytapNativeApi && !!window.HeytapNativeApi.invoke) && /usercenter/i.test(navigator.userAgent.toLowerCase()))
    },
    isOppoApp () {
      return navigator.userAgent.toLowerCase().includes('oppocommunity') && (window.HeytapNativeApi && !!window.HeytapNativeApi.invoke)
    },
    isOneplusCN() {
      return navigator.userAgent.toLowerCase().includes('oneplus') && (window.HeytapNativeApi && !!window.HeytapNativeApi.invoke) && import.meta.env.VITE_COUNTRY === 'CHINA'
    },
    isAppMarket () {
      return navigator.userAgent.toLocaleLowerCase().includes('appmarket') || location.search.includes('fromAppRate')
    },
    appName () {
      let appName = ''
      if(navigator.userAgent.toLowerCase().includes('oppocommunity')){
        appName = 'oppoApp'
      }
      if (navigator.userAgent.toLowerCase().includes('usercenter')) {
        appName = 'myOppo'
      }
      if (navigator.userAgent.toLowerCase().includes('oneplus')) {
        appName = 'oneplusApp'
      }
      if (window.OppoStoreClientStoreJS) {
        appName = 'oppoStore'
      }
      if (window.OnePlusClientBaseJS) {
        appName = 'onePlusStore'
      }
      if (navigator.userAgent.toLocaleLowerCase().includes('appmarket') || location.search.includes('fromAppRate')) {
        appName = 'appMarket'
      }
      return appName
    },
    isWechat () {
      let ua = navigator.userAgent.toLowerCase()
      return /micromessenger/.test(ua)
    },
    isPRD () {
      return !location.origin.includes('test')
    },
    isDev () {
      return import.meta.env.VITE_ENV === 'DEV'
    },
    pocBasicSupport (state) {
      let basicSupport = []
      try {
        const settings = JSON.parse(state.cloudConfig.feedbackSettings)
        basicSupport = [ ...settings.pocBasicSupport ]
      } catch (e) {}
      return basicSupport
    },
    isTest () {
      return location.origin.includes('wanyol') || (/\d/.test(location.origin))
    },
    cdnPath () {
      return this.cloudConfig?.imageCdn
    }
  },
  actions: {
    // 当前终端：web/wap
    setBrowserType (e) {
      this.browserType = e
    },
    // 获取oppo云中的社区配置项
    async setCloudConfig () {
      let response = null
      try {
        response = JSON.parse(document.getElementById('cloud-config').innerText) ?? {}
      } catch {}
      if (!response || response?.code !==200) {
        response = await http.getCloudConfig() || {}
      }
      const { code, data } = response
      if (code === 200) {
        data.functionSwitch = JSON.parse(data.functionSwitch) ?? {}
        this.cloudConfig = { ...data }
        this.customSetting = JSON.parse(data.customSetting) ?? {}
        this.exploreSortMenuSwitch = JSON.parse(data.homeThreadTabSwitch) ?? {}
      }
    },
    // 获取举报原因列表
    async getReportReasons () {
      const { code, data } = await http.getReportReason()
      if (code !== 200) return
      this.reportReasons = [ ...data ]
    },
    // 获取作品历史菜单
    async getAssociationList () {
      const { code, data, msg } = await http.getGalleryCategoryList()
      if (code === 200 && data?.length) {
        data.forEach(i => {
          i.featuredTabNameList = i.galleryCampaignList.map(tag => {
            return {
              label: tag.navigationName,
              value: tag.name
            }
          })
        })
        this.galleryList = data
      }
    },
    // 客户端获取上报任务列表
    async getReportTaskList() {
      const { code, data } = await http.getReportTaskList()
      if (code !== 200) return
      this.reportTaskList = data
    },
    setLanguage (val) {
      this.language = val
    },
    // 获取成长体系json数据
    async queryMembershipJson (type) {
      let data = {}
      data = await fetch(`${this.cdnPath}static/memberShip.json`).then(res => {
        // throw new Error('get level detail fail')
        if (!res.ok) {
          throw new Error('get level detail fail')
        }
        return res.json()
      }).catch(async (e) => {
        data = null
      })
      if (!data) {
        data = await import('@/assets/jsonList/memberShip.json')
      }
      this.ruleLink = data.ruleLink 
      if(!type){
        this.milestoneList = data.milestoneList
        this.milestongStyle = data.milestongStyle
      }else{
        this.inspirationList = data.inspirationList
        this.inspirationStyle = data.inspirationStyle
      }
    }
  }

})